import { Box, Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import React, { useState } from "react";
import CustomTypography from "../../../../components/common/CustomTypography";
import { useOnboardingPromotionPage } from "../../../../hooks/useOnboardingPromotionPage";
import { usePromotionOnboardingTracking } from "../../../../hooks/usePromotionOnboardingTracking";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

interface SelectOption {
  id: number;
  label: string;
}

const selectOptionList: SelectOption[] = [
  { id: 1, label: "자연히 나아질 것" },
  { id: 2, label: "지금과 똑같이 괴로울 것" },
  { id: 3, label: "방치한 지난 1년을 후회할 것" },
];

export default function Goal_10_V6({
  version = "v6",
}: {
  version?: MktVersionTypes;
}) {
  const [, setIsAnimating] = useState(false);

  const pageKey = "goal_10";

  const { singleSelectionId, updateSingleSelection, handleNext } =
    useOnboardingPromotionPage({
      pageKey,
      nextPageRoute: `/${versionToPathPrefix(version)}-onboarding/goal/11`,
    });

  const { trackSingleSelection } = usePromotionOnboardingTracking(
    pageKey,
    version
  );

  const handleOptionChange = (optionId: number) => {
    updateSingleSelection(optionId);
    trackSingleSelection(optionId);

    setTimeout(() => {
      setIsAnimating(false);
      handleNext({ singleSelectionId: optionId });
    }, 300);
  };

  return (
    <Stack spacing={5} sx={{ height: "100%" }}>
      <CustomTypography
        variant="Subtitle"
        fontWeight={500}
        sx={{
          color: theme.vars.palette.Content.Strong,
        }}
      >
        만약 지금 이 문제를 해결하지 않고 1년이 더 지난다면, 나의 삶은 어떻게
        바뀌어 있을까요?
      </CustomTypography>
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <Stack
          direction={"column"}
          sx={{
            width: "100%",
            whiteSpace: "nowrap",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {selectOptionList.map(({ id, label }, optionIndex) => (
            <Stack key={`select_option_${id}`} sx={{ flexGrow: 1, gap: 1 }}>
              <Button
                fullWidth
                variant={"SingleSlim"}
                color={singleSelectionId === id ? "primary" : "secondary"}
                size={"lg"}
                sx={{
                  transition: "background-color 0.3s ease",
                }}
                onClick={() => {
                  handleOptionChange(id);
                }}
              >
                {label}
              </Button>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
